import React, { Fragment } from "react";
import classes from "./productListing.module.css";
import Product from "./product";
import FullPageLoading from "../../../components/FullPageLoading/FullPageLoading";
import { useProductListing } from "../../../Pregrine/CartPage/ProductListing/useProductListing";
import LoadingIndicator from "../../../components/LoadingIndicator";

const ProductListing = (props) => {
  const { setIsCartUpdating, fetchCartDetails } = props;

  const talonProps = useProductListing();

  const { isLoading, items } = talonProps;

  if (isLoading) {
    return <LoadingIndicator />;
  }

  if (items.length) {
    const productComponents = items.map((product) => (
      <Product
        item={product}
        key={product.id}
        setIsCartUpdating={setIsCartUpdating}
        fetchCartDetails={fetchCartDetails}
      />
    ));

    return (
      <Fragment>
        <ul className={classes.root}>{productComponents}</ul>
      </Fragment>
    );
  }

  return null;
};

export default ProductListing;
